import { createContext } from 'use-context-selector';
import { defaultAuthorizationProviderState } from './defaultState';
import { AuthorizationProviderState } from './types';

const AuthorizationContext = createContext<AuthorizationProviderState>(defaultAuthorizationProviderState);

export default AuthorizationContext;
